var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"registration-footer"},[_c('div',{staticClass:"registration-footer__title"},[_c('BaseLine'),_vm._v(" "),_c('span',[_vm._v("Уже есть аккаунт?")]),_vm._v(" "),_c('BaseLine')],1),_vm._v(" "),_c('BaseGhostButtonLink',{staticClass:"--m",attrs:{"href":"/signin/","target":"_blank"}},[_vm._v("\n    войти в мтс линк\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }